import type { components } from "@/services/customer-schema";
import type { components as componentsV1 } from "@/services/kustodian-customer-api-schema";

import { faker } from "@faker-js/faker";

faker.seed(0);

export const beneficiariesV2FirstPage: components["schemas"]["AccountClientListResponseV2"] =
  {
    clients: [
      { clientRef: "beneficiary1V2", updatedAt: "time1" },
      { clientRef: "beneficiary2V2", updatedAt: "time2" },
      { clientRef: "beneficiary3V2", updatedAt: "time3" },
    ],
    pagination: {
      firstCursor: "firstPage",
      nextCursor: "secondPage",
      lastCursor: "secondPage",
      limit: 3,
    },
  };

export const beneficiariesV2SecondPage: components["schemas"]["AccountClientListResponseV2"] =
  {
    clients: [
      { clientRef: "beneficiary4", updatedAt: "time4" },
      { clientRef: "beneficiary5", updatedAt: "time5" },
    ],
    pagination: {
      firstCursor: "firstPage",
      prevCursor: "firstPage",
      lastCursor: "secondPage",
      limit: 3,
    },
  };

export const beneficiariesV2SearchResult: components["schemas"]["AccountClientListResponseV2"] =
  {
    clients: [{ clientRef: "beneficiaryFound", updatedAt: "timeFound" }],
    pagination: {
      limit: 3,
    },
  };

export const beneficiariesUpsertResponse: componentsV1["schemas"]["PersonalInformationApiResponse"] =
  {
    externalId: "beneficiary3",
    beneficiaries: [],
  };

export const beneficiariesGetResponse: componentsV1["schemas"]["PersonalInformationApiResponse"] =
  {
    externalId: "beneficiary3",
    beneficiaries: [
      {
        naturalPerson: {
          name: [
            {
              nameIdentifier: [
                {
                  primaryIdentifier: "Smith",
                  secondaryIdentifier: "John",
                  nameIdentifierType: "LEGL",
                },
              ],
            },
          ],
          geographicAddress: [
            {
              addressType: "HOME",
              room: "1A",
              floor: "2",
              buildingNumber: "1",
              buildingName: "The Cottage",
              streetName: "Client Street",
              townName: "London",
              countrySubDivision: "Greater London",
              postCode: "EC1A 1AA",
              country: "GB",
              addressLine: ["The Cottage", "1 Client Street"],
            },
          ],
        },
      },
    ],
  };

export const ROW_COUNT_FIRST_BENEFICIARY_PAGE = 3;
export const ROW_COUNT_SECOND_BENEFICIARY_PAGE = 2;
export const ROW_COUNT_SEARCH_BENEFICIARY_PAGE = 1;
